(function () {
  function applyModel(model) {
    if (!model) return;
    document.querySelectorAll("[data-series-content-section]").forEach(function (section) {
      var active = section.dataset.model === model;
      section.hidden = !active;
      section.classList.toggle("is-active", active);
    });
    window.setTimeout(function () {
      if (window.AOS && typeof window.AOS.refreshHard === "function") {
        window.AOS.refreshHard();
      } else if (window.AOS && typeof window.AOS.refresh === "function") {
        window.AOS.refresh();
      }
    }, 50);
  }

  function currentModel() {
    var root = document.querySelector(".pb-box-neos-ii-series");
    if (root && root.dataset.model) return root.dataset.model;
    var card = document.querySelector(".series-model-selector .version-link.selected");
    return card ? card.dataset.model : "NEOS II Ultra";
  }

  function init() {
    applyModel(currentModel());
    document.addEventListener("neos-series:model-change", function (event) {
      applyModel(event.detail && event.detail.model);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
